import { htmlE } from "/WebInterface/new-ui/assets/js/utils/te.js";

const editFileTemplate = htmlE`
${({ content }) => {
  return `<textarea id="editFileTextArea" class="w-full h-full is-block">${utils.textEncode(
    content || ""
  )}</textarea>`;
}}
`;

export default editFileTemplate;
